export interface iLocation {
    location_id: number;
    location_name: string;
    location_name_ls?: any;
    location_desc: string;
    location_desc_ls?: any;
    location_image?: string;
    location_beacon_id?: string;
    location_audio_intro?: any;
    location_audio_extended?: any;
    location_fences?: number[];
    created_at: string;
    updated_at: string;
}

export class Location implements iLocation {
    location_id: number = 0;
    location_name: string = "";
    location_name_ls: any = null;
    location_desc: string = "";
    location_desc_ls: any = null;
    location_image: string = "";
    location_beacon_id: string = "";
    location_audio_intro: any = null;
    location_audio_extended: any = null;
    location_fences: number[] = [];
    created_at: string = "";
    updated_at: string = "";

    constructor(options?: iLocation) {
        Object.assign(this, options);
    }
}
